import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Polyline, CircleMarker, Popup } from "react-leaflet";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, fmtDateTime } from "@/lib/api";

const T = (iso) => new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });

export const RouteDialog = ({ row, date, onClose }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!row) return;
    setD(null);
    api.get("/attendance/trail", { params: { user_id: row.user_id, date } }).then((r) => setD(r.data));
  }, [row, date]);
  if (!row) return null;
  const pts = (d?.pings || []).map((p) => [p.latitude, p.longitude]);
  const rec = d?.record;
  const center = pts[0] || (rec?.clock_in_lat != null ? [rec.clock_in_lat, rec.clock_in_lng] : [25.3176, 82.9739]);
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-4xl" data-testid="route-dialog">
        <DialogHeader><DialogTitle className="font-heading text-xl">{row.full_name} · Location trail {date}</DialogTitle></DialogHeader>
        <div className="text-xs text-slate-500">{pts.length} GPS points · login {fmtDateTime(rec?.clock_in_time)} · logout {fmtDateTime(rec?.clock_out_time)}</div>
        <div className="h-[460px] rounded-xl overflow-hidden border" data-testid="route-map">
          {d && (
            <MapContainer center={center} zoom={13} className="h-full w-full">
              <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {pts.length > 1 && <Polyline positions={pts} pathOptions={{ color: "#0284C7", weight: 4 }} />}
              {d.pings.map((p, i) => (
                <CircleMarker key={i} center={[p.latitude, p.longitude]} radius={4} pathOptions={{ color: "#0284C7", fillOpacity: 0.8 }}>
                  <Popup>{T(p.ping_timestamp)}</Popup>
                </CircleMarker>
              ))}
              {rec?.clock_in_lat != null && (
                <CircleMarker center={[rec.clock_in_lat, rec.clock_in_lng]} radius={10} pathOptions={{ color: "#10B981", fillOpacity: 0.9 }}>
                  <Popup>Login {T(rec.clock_in_time)}</Popup>
                </CircleMarker>
              )}
              {rec?.clock_out_lat != null && (
                <CircleMarker center={[rec.clock_out_lat, rec.clock_out_lng]} radius={10} pathOptions={{ color: "#E11D48", fillOpacity: 0.9 }}>
                  <Popup>Logout {T(rec.clock_out_time)}</Popup>
                </CircleMarker>
              )}
            </MapContainer>
          )}
        </div>
        <div className="flex gap-4 text-xs text-slate-600">
          <span className="flex items-center gap-1"><span className="h-3 w-3 rounded-full bg-emerald-500" />Login point</span>
          <span className="flex items-center gap-1"><span className="h-3 w-3 rounded-full bg-sky-600" />Live pings (every minute while app is open)</span>
          <span className="flex items-center gap-1"><span className="h-3 w-3 rounded-full bg-rose-600" />Logout point</span>
        </div>
      </DialogContent>
    </Dialog>
  );
};
